import React, { useState } from "react";
import Breadcrumb from "react-bootstrap/Breadcrumb";
import { Modal, Button } from "react-bootstrap";
import Agamorg from "../../assets/images/portfolio/agamorg.jpg";
import Dixon from "../../assets/images/portfolio/dixon.jpg";
import Fibio from "../../assets/images/portfolio/fibio.jpg";
import OnderShot from "../../assets/images/portfolio/ondershot.jpg";
import Petnotch from "../../assets/images/portfolio/petnotch.jpg";
import SikhMotorCycle from "../../assets/images/portfolio/sikh-motor-cycle-club.jpg";
import Zenoteit from "../../assets/images/portfolio/zenoteit.jpg";
import { faCirclePlay, faLink } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Link } from "react-router-dom";
import EcommerceWeb from "../../assets/images/portfolio/ecommerce-web.png";

export const PortfolioSec = () => {
  const [showModal, setShowModal] = useState(false);
  const [videoUrl, setVideoUrl] = useState("");
  const [modalTitle, setModalTitle] = useState("");

  // Function to open the modal with specific video and title
  const handleShowModal = (url, title) => {
    setVideoUrl(url);
    setModalTitle(title);
    setShowModal(true);
  };

  // Function to close the modal
  const handleCloseModal = () => {
    setShowModal(false);
    setVideoUrl("");
    setModalTitle("");
  };
  return (
    <>
      <div className="common-banner">
        <div className="container">
          <div className="banner-content">
            <h2>Portfolio</h2>
            <nav aria-label="breadcrumb">
              <ol className="breadcrumb">
                <li className="breadcrumb-item">
                  <Link to="/">Home</Link>
                </li>
                <li className="breadcrumb-item active" aria-current="page">
                  Portfolio
                </li>
              </ol>
            </nav>
          </div>
        </div>
      </div>

      <div className="portfolio-sec py-5">
        <div className="container">
          <div className="card p-0 overflow-hidden">
            <div className="card-body p-0">
              <div className="row align-items-center">
                <div className="col-lg-5 mb-3 mb-lg-0">
                  <img src={Agamorg} alt="Agamorg Portfolio Image" />
                </div>
                <div className="col-lg-7">
                  <div className="title ms-0 ms-lg-4">
                    <h2>Agamorg</h2>
                    <h4 className="mb-4 mt-3">
                      <strong>Technology Stack : </strong>
                      React Native, iOS, Android, REST API, Notification
                      Services, App Analytics, Payment Integration.
                    </h4>
                    <p>
                      Agamorg is a specialized e-commerce platform designed to
                      empower farmers by enabling them to buy agricultural
                      products directly through a user-friendly mobile
                      application. The app bridges the gap between farmers and
                      quality farming supplies, ensuring they have access to
                      essential resources efficiently and affordably.
                    </p>
                    <Button
                      className="btn btn-primary"
                      onClick={() =>
                        handleShowModal(
                          "https://www.youtube.com/embed/1qSd7rfZZIY?si=Yc3t6A0FWGXBsWa7",
                          "Agamorg"
                        )
                      }
                    >
                      <FontAwesomeIcon icon={faCirclePlay} className="me-2" />
                      Watch Now
                    </Button>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="card p-0 overflow-hidden">
            <div className="card-body p-0">
              <div className="row align-items-center">
                <div className="col-lg-5 mb-3 mb-lg-0">
                  <img src={Fibio} alt="Agamorg Portfolio Image" />
                </div>
                <div className="col-lg-7">
                  <div className="title ms-0 ms-lg-4">
                    <h2>Fibio</h2>
                    <h4 className="mb-4 mt-3">
                      <strong>Technology Stack : </strong>
                      React Native, iOS, Android, REST API, Notification
                      Services, App Analytics, Payment Integration.
                    </h4>
                    <p>
                      Fibio is your family-friendly and eco-conscious mobile
                      provider, prioritizing simplicity, affordability, flexible
                      services, and personalized customer care. We believe in
                      your choice to be our customer, not an obligation, which
                      is why we proudly offer a 100% satisfaction guarantee to
                      all our customers.
                    </p>
                    <Button
                      className="btn btn-primary"
                      onClick={() =>
                        handleShowModal(
                          "https://youtube.com/embed/8O6TLPiGqmQ?feature=share",
                          "Fibio"
                        )
                      }
                    >
                      <FontAwesomeIcon icon={faCirclePlay} className="me-2" />
                      Watch Now
                    </Button>
                  </div>
                </div>
              </div>
            </div>
          </div>
          {/* <div className="card p-0 overflow-hidden">
            <div className="card-body p-0">
              <div className="row align-items-center">
                <div className="col-lg-5 mb-3 mb-lg-0">
                  <img src={Dixon} alt="Dixon Portfolio Image" />
                </div>
                <div className="col-lg-7">
                  <div className="title ms-0 ms-lg-4">
                    <h2>Dixon</h2>
                    <h4 className="mb-4 mt-3">
                      <strong>Technology Stack : </strong>
                      React Native, iOS, Android, REST API, Notification
                      Services, App Analytics, Payment Integration.
                    </h4>
                    <p>
                      Agamorg is a specialized e-commerce platform designed to
                      empower farmers by enabling them to buy agricultural
                      products directly through a user-friendly mobile
                      application. The app bridges the gap between farmers and
                      quality farming supplies, ensuring they have access to
                      essential resources efficiently and affordably.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div> */}

          <div className="card p-0 overflow-hidden">
            <div className="card-body p-0">
              <div className="row align-items-center">
                <div className="col-lg-5 mb-3 mb-lg-0">
                  <img src={OnderShot} alt="OnderShot Portfolio Image" />
                </div>
                <div className="col-lg-7">
                  <div className="title ms-0 ms-lg-4">
                    <h2>Oneder Shot Golf Competition</h2>
                    <h4 className="mb-4 mt-3">
                      <strong>Technology Stack : </strong>
                      React Native, iOS, Android, REST API, Notification
                      Services, App Analytics, Payment Integration.
                    </h4>
                    <p>
                      Introducing the world's first amateur golf competition
                      with an incredible $10 million USD prize pool! Picture
                      yourself basking in the excitement of winning an
                      all-expenses-paid trip to the thrilling Miami finals*,
                      where you'll get the exclusive chance to take the shot in
                      person and vie for the astonishing $10 million USD prize.
                      Here's your playbook to join in the action: Download our
                      app. Participants have the option to easily download the
                      app on either iOS or Android devices, or they can
                      conveniently purchase qualifying shots directly from our
                      website.
                    </p>
                    <Button
                      className="btn btn-primary"
                      onClick={() =>
                        handleShowModal(
                          "https://www.youtube.com/embed/QGBRY1HQu98",
                          "Oneder Shot Golf Competition"
                        )
                      }
                    >
                      <FontAwesomeIcon icon={faCirclePlay} className="me-2" />
                      Watch Now
                    </Button>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="card p-0 overflow-hidden">
            <div className="card-body p-0">
              <div className="row align-items-center">
                <div className="col-lg-5 mb-3 mb-lg-0">
                  <img src={Petnotch} alt="Petnotch Portfolio Image" />
                </div>
                <div className="col-lg-7">
                  <div className="title ms-0 ms-lg-4">
                    <h2>PetNotch</h2>
                    <h4 className="mb-4 mt-3">
                      <strong>Technology Stack : </strong>
                      React Native, iOS, Android, REST API, Notification
                      Services, App Analytics, Payment Integration, Map.
                    </h4>
                    <p>
                      World's most sophisticated 360° pet management platform,
                      designed to make it easy for pet parents to manage all
                      aspects of their pet's life.
                    </p>
                    <Button
                      className="btn btn-primary"
                      onClick={() =>
                        handleShowModal(
                          "https://www.youtube.com/embed/TI507vU372o?si=BUk2IC7qsAuVyw-h",
                          "PetNotch"
                        )
                      }
                    >
                      <FontAwesomeIcon icon={faCirclePlay} className="me-2" />
                      Watch Now
                    </Button>
                  </div>
                </div>
              </div>
            </div>
          </div>
          {/* <div className="card p-0 overflow-hidden">
            <div className="card-body p-0">
              <div className="row align-items-center">
                <div className="col-lg-5 mb-3 mb-lg-0">
                  <img
                    src={SikhMotorCycle}
                    alt="Sikh Motorcycle Club Portfolio Image"
                  />
                </div>
                <div className="col-lg-7">
                  <div className="title ms-0 ms-lg-4">
                    <h2>Sikh Motorcycle Club</h2>
                    <h4 className="mb-4 mt-3">
                      <strong>Technology Stack : </strong>
                      React Native, iOS, Android, REST API, Notification
                      Services, App Analytics, Payment Integration, Map.
                    </h4>
                    <ul>
                      <li>
                        Riders receive notifications about upcoming rides.
                      </li>
                      <li>
                        Members can opt-in to participate or opt-out if
                        unavailable.
                      </li>
                      <li>
                        Ride Check-In: On the day of the ride, participants can
                        easily check in through the app.
                      </li>
                      <li>
                        Ride History: Track past rides and view details for
                        personal records.
                      </li>
                      <li>
                        Profile Management: Update profile information
                        effortlessly.
                      </li>
                      <li>
                        Change passwords securely using the “Change Password”
                        option.
                      </li>
                      <li>
                        Password Recovery: Utilize the “Forgot Password” feature
                        for quick account recovery.
                      </li>
                    </ul>
                    <Button
                      className="btn btn-primary"
                      onClick={() =>
                        handleShowModal(
                          "https://www.youtube.com/embed/LcMP31uEZgg",
                          "Sikh Motorcycle Club"
                        )
                      }
                    >
                      <FontAwesomeIcon icon={faCirclePlay} className="me-2" />
                      Watch Now
                    </Button>
                  </div>
                </div>
              </div>
            </div>
          </div> */}
          <div className="card p-0 overflow-hidden">
            <div className="card-body p-0">
              <div className="row align-items-center">
                <div className="col-lg-5 mb-3 mb-lg-0">
                  <img src={Zenoteit} alt="Agamorg Portfolio Image" />
                </div>
                <div className="col-lg-7">
                  <div className="title ms-0 ms-lg-4">
                    <h2>ZeNoteit</h2>
                    <h4 className="mb-4 mt-3">
                      <strong>Technology Stack : </strong>
                      React Native, iOS, Android, REST API, Notification
                      Services, App Analytics, Payment Integration,
                      Subscription.
                    </h4>
                    <p>
                      zeNoteit is a smart and efficient task management
                      application designed to help individuals and teams stay
                      organized, prioritize work, and achieve their goals. With
                      a focus on simplicity and functionality, zeNoteit
                      transforms the way you manage tasks, making productivity
                      effortless.
                    </p>
                    <Button
                      className="btn btn-primary"
                      onClick={() =>
                        handleShowModal(
                          "https://youtube.com/embed/daUROLhCijE?feature=share",
                          "ZeNoteit"
                        )
                      }
                    >
                      <FontAwesomeIcon icon={faCirclePlay} className="me-2" />
                      Watch Now
                    </Button>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="card p-0 overflow-hidden">
            <div className="card-body p-0">
              <div className="row align-items-center">
                <div className="col-lg-5 mb-3 mb-lg-0">
                  <img src={EcommerceWeb} alt="Ecommerce Web Portfolio Image" />
                </div>
                <div className="col-lg-7">
                  <div className="title ms-0 ms-lg-4">
                    <h2>Yoella.in</h2>
                    <h4 className="mb-4 mt-3">
                      <strong>Technology Stack : </strong>
                      React.js, REST API, Payment Gateway Integration, Notification Services,Real-time Chat
                    </h4>
                    <p>
                      Yoella.in is a React-based e-commerce web application focused on women's clothing.
                      It offers features like product listing, detailed product pages, cart management, and order tracking.
                      Users can securely purchase products through integrated payment gateways.
                      The platform includes review and rating functionality along with real-time chat support for instant assistance.
                      It is powered by REST APIs, notifications, and analytics to ensure a smooth and optimized user experience.
                    </p>
                    <Button
                      className="btn btn-primary"
                      onClick={() => window.open("https://ciw.codeinfoway.com/", "_blank")}
                    >
                      <FontAwesomeIcon icon={faLink} className="me-2" />
                      Visit Site
                    </Button>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Modal Component */}
          <Modal show={showModal} onHide={handleCloseModal} centered>
            <Modal.Header closeButton>
              <Modal.Title>{modalTitle}</Modal.Title>
            </Modal.Header>
            <Modal.Body>
              {videoUrl ? (
                <div className="embed-responsive embed-responsive-16by9">
                  <iframe
                    className="embed-responsive-item"
                    src={videoUrl}
                    width="100%"
                    height="400px"
                    allowFullScreen
                    title="YouTube video"
                  ></iframe>
                </div>
              ) : (
                <p>No video available.</p>
              )}
            </Modal.Body>
          </Modal>
        </div>
      </div>
    </>
  );
};
